import { render, staticRenderFns } from "./icon-configurator-energy-economy-3.svg?vue&type=template&id=ab58b930&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports